import { FlowOcrBoundingBoxMode, FlowOcrDetailLevel } from 'flow-schema';

import { api } from 'common';

import { OcrV2BlockFormFields } from './FormFields.tsx';
import { OcrV2BlockDocumentationMarkdown } from './documentation.ts';
import type { BlockConfigProps } from '../../../types.ts';

export const ocrV2Config: BlockConfigProps<api.FlowDefinition.OcrV2Block['config']> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'extractText',
  defaultConfig: {
    detailLevel: FlowOcrDetailLevel.None,
    boundingBoxMode: FlowOcrBoundingBoxMode.None,
    fileReference: '',
    method: api.FlowDefinition.RECOMMENDED_OCR_METHOD,
  },
  configFields: {
    schema: api.FlowDefinition.OcrV2BlockConfigSchema,
    FormFields: OcrV2BlockFormFields,
  },
  documentationMarkdown: OcrV2BlockDocumentationMarkdown,
};
